import { isEmpty } from 'lodash';
import Axios from 'axios';

import client from '../utils/client';

import { geolocationApiUrl, googleAPIKey, googleMapAPIKey } from '../constants/configuration';

// all the apis can be called from here

export const fetchMasterDataApi = ({ appName }) => {
  return client().get(`/lookup/appSettings/${appName}`);
};

export const sendOtpApi = (requestBody) => client().post(`/api/v1/auth/otp/request`, requestBody);

export const verifyOtpApi = ({ mobileNumber, countryCode, otp, recover }) =>
  client().post('/api/v1/auth/otp/verify', {
    mobileNumber,
    countryCode,
    otp,
    recover,
  });

export const logoutApi = ({ refreshToken }) =>
  client().post(
    '/api/v1/auth/logout',
    {},
    {
      headers: {
        'X-Refresh-Token': refreshToken,
      },
    },
  );

export const logoutAllDevicesApi = () => client().post('/api/v1/auth/logout-all');

export const attemptLoginApi = async (loginReqBody) =>
  await client().post('/guests/signin', loginReqBody);

export const updateProfileApi = async ({ updateProfileReqBody, guestId }) =>
  await client().put(`/guests/${guestId}`, updateProfileReqBody);

export const getUserProfileDataApi = async ({ guestId }) =>
  await client().get(`/guests/${guestId}`);

export const initiatePaymentApi = ({ initiatePaymentReqBody, defaultGateway }) =>
  client().post(`/api/v1/payments/initiatePayment`, initiatePaymentReqBody, {});

export const validatePaymentApi = ({ paymentresponse, defaultGateway }) =>
  client().post('/payments/paymentResponse', paymentresponse, {
    headers: {
      common: {
        pg: defaultGateway,
      },
    },
  });

export const verifyPaymentApi = ({ id }) => client().post(`api/v1/payments/verifyPayment/${id}`);

export const findGuestLocationApi = ({ guestId }) =>
  client().get(`/guests/findLocation${!isEmpty(guestId) ? `?guestId=${guestId}` : ''}`);

export const findGeoLocationApi = () => client().post(`${geolocationApiUrl}?key=${googleAPIKey}`);

export const validateLocalitiesApi = (validateLocalitiesReqBody) =>
  client().post('/restaurants/deliveries/validateLocalities', validateLocalitiesReqBody);

export const fetchOutletDetailsApi = ({ url }) => client().get(url);

export const createGuestFeedbackApi = (guestFeedbackReqBody) =>
  client().post('/feedback', guestFeedbackReqBody);

export const createOrderFeedbackApi = (orderFeedbackReqBody) =>
  client().post('/feedbacks/create/v2', orderFeedbackReqBody);

export const updateGuestFeedbackApi = ({ guestFeedbackId, guestFeedbackReqBody }) =>
  client().put(`/feedback/${guestFeedbackId}`, guestFeedbackReqBody);

export const getBrandFeedbackSetupApi = ({ brandId }) =>
  client().get(`/brands/feedbacks/setup?brandId=${brandId}`);

export const fetchRewardProgramRulesApi = ({ brandId }) =>
  client().get(`/rewardPrograms?brandId=${brandId}`);

export const fetchBrandResourcesApi = ({ brandId }) => client().get(`/brands/resources/${brandId}`);

export const fetchRewardPointsTransactionsApi = ({ page, size, brandId, brandGuestId, params }) =>
  client().get(
    `/rewardPoints/transactions?page=${page}&size=${size}&brandId=${brandId}&brandGuestId=${brandGuestId}${params}&sort=transactionDate,DESC`,
  );

export const fetchRewardPointsApi = ({ url }) => client().get(url);

export const initiateDeleteAccountApi = ({ brandId, deleteAccountReqBody }) => {
  return client().post(`/brands/initiateDelete/${brandId}`, deleteAccountReqBody);
};

export const initiateDeleteBrandGuestAccountApi = (requestBody) =>
  client().post(`brandGuests/v2`, requestBody);

export const fetchAppStartupInfoApi = ({ appStartupReqBody }) => {
  return client().post(`/appStartup`, appStartupReqBody);
};

export const fetchOrderFeedbackSetupApi = ({ brandId }) =>
  client().get(`/brands/feedbacks/setup?brandId=${brandId}`);

export const fetchfeedbackByIdApi = ({ feedbackId }) =>
  client().get(`/brands/feedbacks/${feedbackId}`);

export const fetchBrandCitiesApi = ({ brandId }) => client().get(`/brands/cities/${brandId}`);

export const fetchMenuItemVariationsApi = ({ restaurantId, menuItemId }) =>
  client().get(`/menus/variations?restaurantId=${restaurantId}&menuItemId=${menuItemId}`);

export const fetchVIPPassesApi = ({ url }) => client().get(url);

export const fetchVIPPassByIdApi = ({ passCode, brandGuestId }) =>
  client().get(
    `/passes/${passCode}${
      !isEmpty(brandGuestId) ? `?includeActiveMembership=true&brandGuestId=${brandGuestId}` : ''
    }`,
  );

export const fetchVIPPassCouponsByIdApi = ({ url }) => client().get(url);

export const fetchPassMembershipsApi = ({ url }) => client().get(url);

export const fetchPassMembershipByIdApi = ({ membershipId, depth }) =>
  client().get(`/passMemberships/${membershipId}${depth ? `?depth=${depth}` : ''}`);

export const subscribePassMembershipApi = ({ subscribePassMembershipReqBody }) =>
  client().post(`/passMemberships/subscribe`, subscribePassMembershipReqBody);

export const deleteGuestAddressApi = (guestAddressBody) =>
  client().post('/brandGuests/v2', guestAddressBody);

export const fetchAllSubBrandsApi = ({ brandId }) =>
  client().post('brands/search', { parent: brandId });

export const paymentOrderPayApi = (payload) => client().post('/paymentOrders/pay', payload);

export const paymentOrderPayApiV2 = (payload) => client().post('/paymentOrders/pay/v2', payload);

export const paymentOrderDetailsApi = ({ params, orderId }) =>
  client().get(`/paymentOrders/${orderId}${params}`);

export const fetchOrderFeedbackByIdApi = ({ feedbackId }) =>
  client().get(`/feedbacks/${feedbackId}`);

export const fetchDeviceIPApi = () => Axios.get('https://api.ipify.org?format=json');

export const fetchLocationByIPApi = (ip) => Axios.get(`https://ipinfo.io/${ip}/geo`);

export const validateReferralCodeApi = ({ validateReferralCodeReqBody }) =>
  client().post(`referrals/validateCode`, validateReferralCodeReqBody);

export const fetchReferralCodeApi = ({ brandGuestId }) =>
  client().get(`referrals/codes/active?brandGuestId=${brandGuestId}`);

export const generateReferralCodeApi = ({ generateReferralCodeReqBody }) =>
  client().post(`referrals/codes/generate`, generateReferralCodeReqBody);

export const fetchReferralDealsApi = ({ dealIds }) => client().get(`/deals/?dealIds=${dealIds}`);

export const fetchUserDetailsApi = ({ userId, accessToken }) =>
  client().get(`/api/v1/users`, {
    data: { id: userId },
    // Add access token to request headers (For All API request we add access token in headers in client.js, adding it here for this specific request as the accessToken may not be saved in localstorage at time of this request)
    ...(!isEmpty(accessToken) && { headers: { Authorization: `Bearer ${accessToken}` } }),
  });

export const updateUserDetailsApi = (updateUserDetailsReqBody) =>
  client().put(`/api/v1/users`, updateUserDetailsReqBody);

export const fetchGoogleMapsApi = ({ latitude, longitude }) =>
  Axios.get(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${googleMapAPIKey}`,
  );

export const deleteUserAccountApi = () => client().delete(`/api/v1/users`);

export const recoverAccountApi = ({ recoverAccountReqBody }) =>
  client().post(`/api/v1/auth/otp/recover`, recoverAccountReqBody);

export const fetchAppResourcesApi = ({ resourcesReqBody }) =>
  client().post(`/api/v1/resources/config`, resourcesReqBody);

export const fetchUserConsentsApi = () => client().get(`/api/v1/consents`);

export const updateUserConsentsApi = ({ updateUserConsentsReqBody }) =>
  client().post(`/api/v1/consents`, updateUserConsentsReqBody);

export const fetchExpertBookingsApi = ({ url }) => client().get(url);

export const serviceOTPSessionApi = ({ otp, bookingId, isServiceInProgress }) =>
  client().post(`/api/v1/expert/bookings/${bookingId}/${isServiceInProgress ? 'end' : 'start'}`, {
    otp,
  });

export const fetchBookingHistoryApi = ({ url }) => client().get(url);

export const fetchBookingDetailsByIdApi = ({ bookingId }) =>
  client().get(`/api/v1/bookings/${bookingId}`);

export const fetchBookingFeedbackOptionsApi = ({ bookingId, rating, locale }) =>
  client().get(`/api/v1/bookings/${bookingId}/feedback/options?rating=${rating}`, {
    headers: { 'Accept-Language': locale },
  });

export const fetchBookingFeedbackStatusApi = ({ bookingId }) =>
  client().get(`/api/v1/bookings/${bookingId}/feedback`);

export const fetchExpertFeedbackSummaryApi = ({ expertId }) =>
  client().get(`/api/v1/experts/${expertId}/feedback-summary`, {
    headers: { Accept: 'application/json' },
  });

export const createBookingFeedbackApi = ({ bookingId, bookingFeedbackReqBody }) =>
  client().post(`/api/v1/bookings/${bookingId}/feedback`, bookingFeedbackReqBody);
